import { PaperProps } from "@mui/material";
import classNames from "classnames";

import { Content } from "./PageCentredContent.styles";

type PageCentredContentProps = PaperProps & {
  chilren?: React.ReactNode;
  bare?: boolean;
};

export const PageCentredContent: React.FC<PageCentredContentProps> = ({ children, bare, elevation = 1, ...props }: PageCentredContentProps) => {
  return (
    <Content elevation={elevation} {...props} className={classNames({ bare })}>
      {children}
    </Content>
  );
};
